import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3858fb07&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3858fb07')) {
      api.createRecord('3858fb07', component.options)
    } else {
      api.reload('3858fb07', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3858fb07&", function () {
      api.rerender('3858fb07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tenant/index.vue"
export default component.exports